import { AnalyticsEvent } from '@com-delta-idp/mnx-utils';
import { DisplayProperties } from '../../../models/common.interfaces';
import { LevelType, TierType } from '../../../models/tier.types';
import { Details } from '../components/details/models/details.interfaces';
import { Status } from '../components/status/models/status.interfaces';

export interface MedallionBannerAriaLabel {
  skyPriority: string;
  level: string;
}

export interface GenericLabel {
  title: string;
  subtitle?: string;
}

export interface MachTier extends GenericLabel {
  level: LevelType;
  name: TierType;
}

export interface MedallionBanner extends DisplayProperties {
  details: Details;
  status: Status;
  ariaLabel: MedallionBannerAriaLabel;
  analyticsEvent?: AnalyticsEvent;
}
